import { gsap, TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine, Linear } from 'gsap'
import { trace } from 'rytm-helpers';
import { initASwap } from './aswap'

export const loadingSequence = () => {
  const box = document.getElementById("box-loading")
  if (box) {
    initIntro(box)
  } else {
    onLoadingComplete()
  }
  
}

const onLoadingComplete = () => {
  initASwap()
  // remove index-loading class name after delay
  setTimeout(() => {
    document.documentElement.classList.remove("index-loading")
  }, 1200)
}
const initIntro = (el) => {  
  const bg = el.querySelector(".bg")
  const t = new TimelineMax()
  t.to(bg, .1, { alpha: 1, onComplete: onLoadingComplete })
  t.to(bg, .4, { autoAlpha: 0, ease: Power2.easeIn, delay: 0 })
}